export default __webpack_public_path__ + "static/media/2005-AMCover.d6913ba9.png";